import { render, staticRenderFns } from "./sSelectPosition.vue?vue&type=template&id=e81b2010"
import script from "./sSelectPosition.vue?vue&type=script&lang=js"
export * from "./sSelectPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports